import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import classes from "../../DatosCliente.module.css";
import Theme from "../../../../../constants/Theme";
import { getFormasPago } from "../../../../../controllers/informacion";

function FormaPagoCfdi({
  formik,
  showToast,
  isActive,
  cfdiSelected,
  setCfdiSelected,
  cfdis,
}) {
  const [formaPagoSelected, setFormaPagoSelected] = useState("");
  const [formasPago, setFormasPago] = useState([]);

  useEffect(() => {
    getFormasPago()
      .then((res) => setFormasPago(res))
      .catch((err) =>
        showToast({
          type: "error",
          err,
        })
      );
  }, []);

  //Detecta cuando se esta reiniciando el form
  useEffect(() => {
    if (isActive === 1) {
      setFormaPagoSelected("");
    }
  }, [isActive]);

  //Cuando cambia la forma de pago, actualizamos el valor del form
  useEffect(() => {
    if (formaPagoSelected && formaPagoSelected !== "") {
      formik.setFieldValue("formaPago", formaPagoSelected, true);
    }
  }, [formaPagoSelected]);

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={2}
      style={{ marginBottom: 10 }}
    >
      <Box style={{ flex: "1 1 45%" }}>
        <FormControl fullWidth>
          <InputLabel>Forma de pago</InputLabel>
          <Select
            label="Forma de pago"
            onChange={({ target: { value } }) => {
              setFormaPagoSelected(value);
            }}
            value={formaPagoSelected}
            error={formik.errors.formaPago && formik.touched.formaPago}
            defaultValue=""
          >
            {formasPago.length > 0 &&
              formasPago.map((formaPago, index) => (
                <MenuItem
                  value={formaPago.epicorId}
                  key={`forma-pago-${formaPago.id}`}
                >
                  {`${formaPago.satId} - ${formaPago.descripcion}`}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <p
          style={
            formik.errors.formaPago && formik.touched.formaPago
              ? { color: Theme.COLORS.ERROR }
              : {}
          }
          className="helperText"
        >
          {formik.errors.formaPago && formik.touched.formaPago
            ? formik.errors.formaPago
            : "Selecciona la forma de pago"}
        </p>
      </Box>
      <Box className={classes.secondLine} style={{ flex: "1 1 50%" }}>
        <FormControl fullWidth>
          <InputLabel>Uso de CFDI</InputLabel>
          <Select
            label="Uso de CFDI"
            onChange={({ target: { value } }) => {
              setCfdiSelected(value);
            }}
            value={cfdiSelected}
            error={formik.errors.usoCFDI && formik.touched.usoCFDI}
          >
            {cfdis.length > 0 &&
              cfdis.map((cfdi, index) => (
                <MenuItem value={cfdi.codigo} key={`cfdi-${cfdi.codigo}`}>
                  {`${cfdi.codigo} - ${cfdi.descripcion}`}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <p
          style={
            formik.errors.usoCFDI && formik.touched.usoCFDI
              ? { color: Theme.COLORS.ERROR }
              : {}
          }
          className="helperText"
        >
          {formik.errors.usoCFDI && formik.touched.usoCFDI
            ? formik.errors.usoCFDI
            : "Selecciona uso CFDI"}
        </p>
      </Box>
    </Stack>
  );
}

export default FormaPagoCfdi;
